export const profileInfoList = [
  {
    title: `location`,
    text: `Seoul, South Korea`,
  },
  {
    title: `email`,
    text: `<a href="mailto:jiyoungvvvvv@gmail.com" title="Send to Email">jiyoungvvvvv@gmail.com</a>`,
  },
  {
    title: `github`,
    text: `<a href="https://github.com/jiyoungv" target="_blank" rel="noreferrer">https://github.com/jiyoungv</a>`,
  },
  {
    title: `linkedin`,
    text: `<a href="https://www.linkedin.com/in/jyp-dev/" target="_blank" rel="noreferrer">https://www.linkedin.com/in/jyp-dev/</a>`,
  },
  {
    title: `skill`,
    text: `HTML, CSS, SASS(SCSS), JavaScript(ES6+), jQuery, React, CSS-in-JS, Redux, Recoil, TypeScript, Storybook, GIT`,
  },
  {
    title: `experience`,
    text: `Next.js, Node.js, JSP, PHP, Figma, Zeplin, Photoshop, Cafe24, WordPress`,
  },
];

export const careerList = [
  {
    name: `주식회사 바이브컴퍼니<br/>(구 다음소프트)`,
    link: `https://www.vaivcompany.kr/`,
    startDate: 202103,
    endDate: null,
    descriptions: [
      '자사 및 타사 서비스 구축 퍼블리싱 업무',
      '자사 서비스 운영 퍼블리싱 업무 - 기능 및 페이지 추가, 코드 개선 등',
      'UX1그룹 총괄 관리 업무 - 디자인, 퍼블리싱 업무 배분 및 일정 관리 등',
      '24.01~ AI솔루션부문 애플리케이션팀 UX1그룹 그룹장',
      '23.07~23.12 AI사업부문 신기술사업팀 전사지원셀 셀장',
      '23.07~23.12 AI사업부문 신기술사업팀 기술사업그룹 그룹원',
      '23.03 책임 진급',
      '22.12~23.06 AI사업부문 기술전략팀 BX그룹 그룹장',
      '22.07~22.11 경영전략실 기술전략팀 팀원',
      '21.03~22.06 썸트렌드부문 UIUX팀 팀원',
    ],
    projects: [
      {
        devices: ['Responsive'],
        name: 'VAIV 생활변화관측소 구독 서비스 구축',
        link: {
          prod: null,
          test: null,
          git: null,
        },
        skills: ['React', 'Next.js', 'TypeScript', 'TailwindCSS'],
        startDate: 202403,
        endDate: null,
        descriptions: [
          '현재 개발 진행 중',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'VAIV AI 포털 서비스 운영',
        link: {
          prod: 'https://www.vaiv.kr/',
          test: null,
          git: null,
        },
        skills: ['React', 'Next.js', 'TypeScript'],
        startDate: 202307,
        endDate: null,
        descriptions: null,
      },
      {
        devices: ['Responsive'],
        name: 'VAIV 회사 소개 웹사이트 운영',
        link: {
          prod: 'https://www.vaivcompany.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202207,
        endDate: null,
        descriptions: null,
      },
      {
        devices: ['Responsive'],
        name: 'VAIV 통합 ID 서비스 구축',
        link: {
          prod: null,
          test: null,
          git: null,
        },
        skills: ['React', 'TypeScript', 'SCSS'],
        startDate: 202402,
        endDate: 202403,
        descriptions: [
          '현재 개발 진행 중',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'VAIV Law 구축',
        link: {
          prod: 'https://law.vaiv.kr/',
          test: 'https://jiyoungv.github.io/test/vaiv-law/',
          git: 'https://github.com/jiyoungv/vaiv-law-pub',
        },
        skills: ['SCSS', 'jQuery'],
        startDate: 202310,
        endDate: 202310,
        descriptions: [
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'VAIV Bio-discovery 구축',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/vaiv-bio-discovery/',
          git: 'https://github.com/jiyoungv/vaiv-bio-discovery-pub',
        },
        skills: ['React', 'SCSS'],
        startDate: 202309,
        endDate: 202309,
        descriptions: [
          '현재 개발 진행 중',
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'VAIV AI Platform 구축',
        link: {
          prod: 'https://ai.vaiv.kr/',
          test: null,
          git: null,
        },
        skills: ['React', 'Next.js', 'TypeScript', 'SCSS'],
        startDate: 202307,
        endDate: 202307,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'VAIV 생성 AI Demo 웹페이지 제작',
        link: {
          prod: 'https://stat.some.co.kr/ai/',
          test: null,
          git: null,
        },
        skills: ['React', 'SCSS'],
        startDate: 202305,
        endDate: 202305,
        descriptions: [
          '디자인, 퍼블리싱 95% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Basil Club 인플루언서 매니지먼트 서비스 구축',
        link: {
          prod: 'https://basilclub.vaiv.kr/',
          test: null,
          git: null,
        },
        skills: ['React', 'Next.js', 'styled-components'],
        startDate: 202303,
        endDate: 202305,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Ttab 컨텐츠 큐레이션 서비스 구축',
        link: {
          prod: null,
          test: null,
          git: null,
        },
        skills: ['React', 'Next.js', 'Recoil', 'styled-components'],
        startDate: 202207,
        endDate: 202303,
        descriptions: [
          '현재 개발 중단',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'Tech Vridge 자사 솔루션 소개 서비스 구축',
        link: {
          prod: null,
          test: 'https://techvridge.vaiv.kr/',
          git: 'https://github.com/jiyoungv/vaiv-tc-pub',
        },
        skills: ['React', 'Next.js', 'Recoil', 'styled-components', 'Storybook'],
        startDate: 202212,
        endDate: 202301,
        descriptions: [
          '현재 개발 중단, 퍼블리싱만 완료 상태',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '미래에셋증권 AI 리포트 서비스 구축',
        link: {
          prod: 'https://economist.co.kr/article/view/ecn202212200079',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202207,
        endDate: 202211,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'LG U+ 소셜 빅데이터 분석 서비스 구축',
        link: {
          prod: 'https://lgu.some.co.kr/',
          test: null,
          git: null,
        },
        skills: ['SCSS', 'jQuery'],
        startDate: 202205,
        endDate: 202206,
        descriptions: [
          '퍼블리셔 PL',
          '퍼블리싱 70% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: 'Sometrend 빅데이터 분석 서비스 운영',
        link: {
          prod: 'https://some.co.kr/',
          test: null,
          git: null,
        },
        skills: ['SCSS', 'Webpack', 'jQuery'],
        startDate: 202103,
        endDate: 202206,
        descriptions: null,
      },
      {
        devices: ['PC'],
        name: 'Innocean 소셜 빅데이터 분석 서비스 구축',
        link: {
          prod: 'https://inno.some.co.kr/',
          test: null,
          git: null,
        },
        skills: ['SCSS', 'jQuery'],
        startDate: 202112,
        endDate: 202201,
        descriptions: [
          '퍼블리싱 20% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: 'Sometrend Biz 빅데이터 분석 서비스 리뉴얼',
        link: {
          prod: 'https://biz.some.co.kr/',
          test: null,
          git: null,
        },
        skills: ['SCSS', 'jQuery'],
        startDate: 202111,
        endDate: 202112,
        descriptions: [
          '퍼블리싱 10% 참여',
        ],
      },
    ],
  },
  {
    name: `조인스엠`,
    link: `http://joinsm.com/`,
    startDate: 201806,
    endDate: 202008,
    descriptions: [
      'SOCAR, 국립현대미술관 문화재단, 병의원, 식당, 쇼핑몰, 자사 서비스 등 30개 이상의 웹사이트 구축 퍼블리싱',
      '기존 웹사이트 운영 퍼블리싱',
      '웹개발팀 소속',
    ],
    projects: [
      {
        devices: ['Responsive'],
        name: '헤라룩스 웹사이트 구축',
        link: {
          prod: 'http://heralux.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202007,
        endDate: 202007,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '서울홍치과 웹사이트 구축',
        link: {
          prod: 'http://seoulhongdental.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202006,
        endDate: 202006,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '서울정진치과 웹사이트 구축',
        link: {
          prod: 'http://seouljjdental.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202005,
        endDate: 202006,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: '국립현대미술관 문화재단 웹사이트 리뉴얼',
        link: {
          prod: 'http://www.mmcafoundation.or.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202004,
        endDate: 202004,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '연세삼성정신과 웹사이트 구축',
        link: {
          prod: 'http://ysmindclinic.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202003,
        endDate: 202003,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '뷰클라인의원 웹사이트 구축',
        link: {
          prod: 'http://vucline.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202001,
        endDate: 202001,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '마이핏슈즈 웹사이트 구축',
        link: {
          prod: 'http://myfitshoes.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201912,
        endDate: 201912,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'SOCAR 휴가지원 이벤트 웹페이지 제작',
        link: {
          prod: 'https://event2019.socar.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201911,
        endDate: 201911,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '끌레어의원 웹사이트 구축',
        link: {
          prod: 'http://cclaire.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201911,
        endDate: 201911,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '조인스엠글로벌 웹사이트 구축',
        link: {
          prod: 'http://joinsmglobal.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201910,
        endDate: 201910,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '야누스타 웹사이트 구축',
        link: {
          prod: 'http://www.janustar.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201909,
        endDate: 201910,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: '타토아의원 고양점 웹사이트 구축',
        link: {
          prod: 'http://www.tatoastar.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201909,
        endDate: 201910,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: '리앤안의원 웹사이트 리뉴얼',
        link: {
          prod: 'http://leeahnclinic.co.kr/m/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201908,
        endDate: 201908,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '탐클리닉 웹사이트 리뉴얼',
        link: {
          prod: 'http://tamclinic.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201907,
        endDate: 201907,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '더리턴피부과 웹사이트 구축',
        link: {
          prod: 'http://thereturnclinicseoul.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201906,
        endDate: 201906,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '더마스터의원 웹사이트 구축',
        link: {
          prod: 'http://dermasterdj.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201906,
        endDate: 201906,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '스포츠잡알리오 웹사이트 구축',
        link: {
          prod: 'http://sportsjobalio.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201906,
        endDate: 201906,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '남다른 인테리어 웹페이지 제작',
        link: {
          prod: 'http://namdaleun.cafe24.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201906,
        endDate: 201906,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '예뻐진의원 잠실점 웹사이트 구축',
        link: {
          prod: 'http://yepclinicjs.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201905,
        endDate: 201905,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '히로신경외과의원 웹사이트 구축',
        link: {
          prod: 'http://heroclinic.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201904,
        endDate: 201904,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '지티툴링 웹사이트 구축',
        link: {
          prod: 'http://gttooling.cafe24.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201903,
        endDate: 201903,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '척편한마취통증의학과의원 웹사이트 구축',
        link: {
          prod: 'http://chuckwell.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201903,
        endDate: 201903,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '조인스엠 디자인 웹사이트 구축',
        link: {
          prod: 'http://joinsm.com/_old/design/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201902,
        endDate: 201902,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '같은마음정신건강의학과 웹사이트 구축',
        link: {
          prod: 'http://likeminded.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201901,
        endDate: 201901,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Reponsive'],
        name: '서울365소아청소년과의원 웹사이트 구축',
        link: {
          prod: 'http://www.seoul365ped.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201901,
        endDate: 201901,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Reponsive'],
        name: '여화담 웹사이트 구축',
        link: {
          prod: 'http://yhdam.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201901,
        endDate: 201901,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Reponsive'],
        name: '케이부스터 웹사이트 구축',
        link: {
          prod: 'http://k-booster.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201901,
        endDate: 201901,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Reponsive'],
        name: '킨더가든포독 웹사이트 구축',
        link: {
          prod: 'http://kg4dog.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201901,
        endDate: 201901,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: '레이저옵텍 웹사이트 구축',
        link: {
          prod: 'http://www.laseroptek.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201812,
        endDate: 201812,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: '이레생한의원 웹사이트 구축',
        link: {
          prod: 'http://ireseng.co.kr/m/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201811,
        endDate: 201811,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '발트하우스 웹사이트 구축',
        link: {
          prod: 'http://waldhaus.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201811,
        endDate: 201811,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '아르웬부띠끄 웹사이트 구축',
        link: {
          prod: 'http://arwenboutique.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201811,
        endDate: 201811,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: '플라이강원 웹사이트 구축',
        link: {
          prod: 'https://flygangwon.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201809,
        endDate: 201809,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: '바비의원 웹사이트 구축',
        link: {
          prod: 'http://www.ok-babi.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201808,
        endDate: 201808,
        descriptions: [
          '현재 사이트 접속 불가',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: '키플러스의원 웹사이트 구축',
        link: {
          prod: 'http://key-plus.co.kr/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 201807,
        endDate: 201807,
        descriptions: [
          '퍼블리싱 100% 참여',
        ],
      },
    ],
  },
  {
    name: `프리랜서`,
    link: null,
    startDate: null,
    endDate: null,
    descriptions: [
      '커피챗, 경성문화사, 더즈인터랙티브, 조인스엠 등 다양한 클라이언트와 협업',
    ],
    projects: [
      {
        devices: ['Responsive'],
        name: '한국해양교통안전공단 웹진 22년 가을호 웹사이트 수정',
        link: {
          prod: 'https://komsa-webzine.co.kr/page/vol51/index.php?volNum=vol51',
          test: null,
          git: null,
        },
        skills: null,
        startDate: 202209,
        endDate: 202209,
        descriptions: [
          '클라이언트 - 경성문화사',
          '비상주',
          '기존 템플릿에 컨텐츠 수정',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 포트폴리오 리뷰 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-pf220803/',
          git: 'https://github.com/jiyoungv/coffeechat-pf220803',
        },
        skills: ['React', 'styled-components'],
        startDate: 202208,
        endDate: 202208,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 제안 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-chat220630/',
          git: 'https://github.com/jiyoungv/coffeechat-chat220630',
        },
        skills: ['React', 'styled-components'],
        startDate: 202206,
        endDate: 202207,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 신청 · 결제 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-request220617/',
          git: 'https://github.com/jiyoungv/coffeechat-request220617',
        },
        skills: ['React', 'styled-components'],
        startDate: 202206,
        endDate: 202206,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Coffeechat 파트너 소개 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-partner220415/',
          git: 'https://github.com/jiyoungv/coffeechat-partner220415',
        },
        skills: ['React', 'styled-components'],
        startDate: 202204,
        endDate: 202204,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Coffeechat 서비스 소개 웹페이지 제작',
        link: {
          prod: 'https://www.coffeechat.kr/',
          test: 'https://jiyoungv.github.io/test/coffeechat-intro220205/',
          git: 'https://github.com/jiyoungv/coffeechat-intro220205',
        },
        skills: ['React', 'styled-components'],
        startDate: 202202,
        endDate: 202202,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 퀴즈 이벤트 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-event211231/',
          git: 'https://github.com/jiyoungv/coffeechat-event211231',
        },
        skills: ['React', 'styled-components'],
        startDate: 202112,
        endDate: 202201,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Coffeechat 자주묻는질문 웹페이지 제작',
        link: {
          prod: 'https://www.coffeechat.kr/faq',
          test: 'https://jiyoungv.github.io/test/coffeechat-faq211221/',
          git: 'https://github.com/jiyoungv/coffeechat-faq211221',
        },
        skills: ['React', 'styled-components'],
        startDate: 202112,
        endDate: 202112,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 이벤트 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-event210806/',
          git: 'https://github.com/jiyoungv/coffeechat-event210806',
        },
        skills: ['React', 'styled-components'],
        startDate: 202108,
        endDate: 202108,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 이벤트 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-event210718/',
          git: 'https://github.com/jiyoungv/coffeechat-event210718',
        },
        skills: ['React', 'styled-components'],
        startDate: 202107,
        endDate: 202107,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '한국수력원자력 웹진 21년 7월호 웹사이트 수정',
        link: {
          prod: 'https://www.khnp.co.kr/webzine/page/vol240/index.html',
          test: null,
          git: null,
        },
        skills: null,
        startDate: 202107,
        endDate: 202107,
        descriptions: [
          '클라이언트 - 경성문화사',
          '비상주',
          '기존 템플릿에 컨텐츠 수정',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '한국과수농협연합회 과일간식 사진공모전 웹사이트 구축',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/snack/',
          git: 'https://github.com/jiyoungv/kyungsungmedia-contest2106',
        },
        skills: ['jQuery'],
        startDate: 202106,
        endDate: 202106,
        descriptions: [
          '클라이언트 - 경성문화사',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '한국수력원자력 웹진 21년 6월호 웹사이트 수정',
        link: {
          prod: 'https://www.khnp.co.kr/webzine/page/vol239/index.html',
          test: null,
          git: null,
        },
        skills: null,
        startDate: 202106,
        endDate: 202106,
        descriptions: [
          '클라이언트 - 경성문화사',
          '비상주',
          '기존 템플릿에 컨텐츠 수정',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['MO'],
        name: 'Coffeechat 이벤트 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-event210613/',
          git: 'https://github.com/jiyoungv/coffeechat-event210613',
        },
        skills: ['React', 'styled-components'],
        startDate: 202106,
        endDate: 202106,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Coffeechat 소개 웹페이지 제작',
        link: {
          prod: null,
          test: 'https://jiyoungv.github.io/test/coffeechat-intro210609/',
          git: 'https://github.com/jiyoungv/coffeechat-intro210609',
        },
        skills: ['React', 'styled-components'],
        startDate: 202106,
        endDate: 202106,
        descriptions: [
          '클라이언트 - 커피챗',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'SK magic 회사소개 웹사이트 구축',
        link: {
          prod: 'https://company.skmagic.com/',
          test: null,
          git: null,
        },
        skills: ['SCSS', 'jQuery'],
        startDate: 202011,
        endDate: 202012,
        descriptions: [
          '클라이언트 - 더즈인터랙티브',
          '상주',
          '퍼블리싱 30% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '서울자이치과 웹사이트 구축',
        link: {
          prod: 'http://seoulxidental.com/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202011,
        endDate: 202012,
        descriptions: [
          '클라이언트 - 조인스엠',
          '비상주',
          '퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC', 'MO'],
        name: 'AMAXG 소개 웹페이지 제작',
        link: {
          prod: 'https://amaxg.net/',
          test: null,
          git: null,
        },
        skills: ['jQuery'],
        startDate: 202008,
        endDate: 202008,
        descriptions: [
          '클라이언트 - 허그매니지먼트',
          '비상주',
          '모바일 디자인, 퍼블리싱 100% 참여',
        ],
      },
    ],
  },
  {
    name: `퍼스널`,
    link: null,
    startDate: null,
    endDate: null,
    descriptions: [
      '개인적으로 진행한 프로젝트',
    ],
    projects: [
      {
        devices: ['PC'],
        name: '포트폴리오 v3',
        link: {
          prod: 'https://jiyoungv.github.io/portfolio/v3/',
          test: null,
          git: 'https://github.com/jiyoungv/portfolio-v3/',
        },
        skills: ['React', 'SCSS'],
        startDate: 202309,
        endDate: 202309,
        descriptions: [
          '현재 사이트',
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: 'Simple TO-DO',
        link: {
          prod: 'https://nextjs-simple-todo.vercel.app/',
          test: null,
          git: 'https://github.com/jiyoungv/nextjs-simple-todo',
        },
        skills: ['React', 'Next.js', 'Redux', 'styled-components'],
        startDate: 202102,
        endDate: 202102,
        descriptions: [
          '리액트, 리덕스 스터디 토이 프로젝트',
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['Responsive'],
        name: '포트폴리오 v2',
        link: {
          prod: 'https://jiyoungv.github.io/portfolio/v2/',
          test: null,
          git: 'https://github.com/jiyoungv/portfolio-v2/',
        },
        skills: ['Babel'],
        startDate: 202012,
        endDate: 202012,
        descriptions: [
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
      {
        devices: ['PC'],
        name: '포트폴리오 v1',
        link: {
          prod: 'https://jiyoungv.github.io/portfolio/v1/',
          test: null,
          git: 'https://github.com/jiyoungv/portfolio-v1/',
        },
        skills: null,
        startDate: 201805,
        endDate: 201805,
        descriptions: [
          '디자인, 퍼블리싱 100% 참여',
        ],
      },
    ],
  },
];